import { ApisauceInstance } from 'apisauce';

const sendPasswordResetEmailUnauthenticated = (
  email: string,
  api: ApisauceInstance,
) => api.post(`/v1/reset_password`, { email });

export default sendPasswordResetEmailUnauthenticated;
